import { useEffect } from 'react';
import type { TransportAuctionServiceRootResponse } from 'src/apis/transport-auction/types';
import { useAxios } from 'src/hooks/use-axios';

const availableStages =
  PRISMA_CONFIG.stage === 'local' ||
  PRISMA_CONFIG.stage === 'storybook' ||
  PRISMA_CONFIG.stage === 'ent' ||
  PRISMA_CONFIG.stage === 'int';

export function useOptionalTransportAuctionServiceRoot() {
  const root = useAxios(
    (axios, baseConfig) =>
      axios.request<TransportAuctionServiceRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.transportAuction,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'transport-auction-service-root',
    }
  );

  useEffect(() => {
    if (!availableStages) return;
    root.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  if (!availableStages) return;

  return root;
}

export type OptionalTransportAuctionServiceRootRequest = ReturnType<
  typeof useOptionalTransportAuctionServiceRoot
>;

export function useTransportAuctionServiceRoot() {
  const root = useAxios(
    (axios, baseConfig) =>
      axios.request<TransportAuctionServiceRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.transportAuction,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'transport-auction-service-root',
    }
  );

  useEffect(() => {
    root.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return root;
}

export type TransportAuctionServiceRootRequest = ReturnType<
  typeof useTransportAuctionServiceRoot
>;
